import cn from 'bem-cn';

import { Stack } from '../../components/UI';
import { useGetChallengesQuery } from '../../store';
import { BigTitleWithText } from '../../components/BigTitleWithText';

import { renderChallengeList, renderSkeletonList } from './ChallengeListPage.helpers';
import './ChallengeListPage.scss';

const b = cn('challenge-list-page');

export const ChallengeListPage = () => {
    const { data, isFetching } = useGetChallengesQuery();

    return (
        <Stack className={b()}>
            <BigTitleWithText title="Давайте соревноваться" text="ИИ-челленджи с реальными призами" />
            <div className={b('challenge-list')}>{isFetching ? renderSkeletonList() : renderChallengeList(data)}</div>
        </Stack>
    );
};
